import axios from "axios";
import { API_BASE_URL, buildHeaders } from "utils/services";

export const cancelGoliathsPlusSubscription = async (user, user_uuid) => {
  try {
    const { data } = await axios.delete(`${API_BASE_URL}/subscriptions/goliaths-plus/${user_uuid}/cancel`,
      buildHeaders(user)
    )
    return data
  } catch (error) {
    console.error(error);
    throw error
  }
}